<!-- <ul class="nav nav-tabs">
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{'active':selMenu=='level'}" (click)="selectMenu('level')">Level</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{'active':selMenu == 'roles'}" (click)="selectMenu('roles')">Roles</a>
  </li>
</ul> -->

<section *ngIf="selMenu == 'level'" class="mt-4" style="overflow-x: auto;height: 70vh;">
  <section class="d-flex justify-content-between" style="gap: 5px;">
    <button type="submit" class="btn btn-dark mb-2" (click)="add(Add)"><i aria-hidden="true" class="fa fa-plus-circle"></i> Create New Level</button>
  </section>
  <table class="table table-hover white_box shadow">
    <thead>
      <tr>
        <th scope="col">Level</th>
        <th scope="col">Level Name</th>
        <th scope="col">Level Description</th>
        <th scope="col">Role Assign</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of list; let i = index;">
        <th scope="row">{{item?.levelID}}</th>
        <td>{{item?.levelName | uppercase}}</td>
        <td>{{item?.description}}</td>
        <td width="500">
          <div class="d-flex">
            <select class="form-control" style="max-width: 20rem;" (change)="onRoleChange($event.target.value)">
              <option [value]="null">Add Role for Level</option>
              <option [value]="r.roleId" *ngFor="let r of (roleList || [])"> {{r?.roleName}}</option>
            </select>
            <span class="px-2 d-flex justify-content-center" style="align-items: center;">
              <button type="button" class="btn btn-primary d-flex" (click)="addRoleToLevel(item.levelID,(item?.roleLevels || []))"><i class="fa fa-plus-circle mr-2" title="Add Role" aria-hidden="true" style="font-size: 1.5rem;"></i> Add Role</button>
            </span>
          </div>
          <section class="row mt-3 mx-1" style="max-width: 35rem;">
            <span class="sub-cate my-1" style="width: fit-content;" *ngFor="let j of (item?.roleLevels || [])">{{j?.role?.roleName || ''}} <i class="fa fa-times" aria-hidden="true" (click)="deleteMemberLevelsRelationship(j.roleLevelID)"></i></span>
          </section>
        </td>
        <td class="text-right">
          <section class="d-flex justify-content-center" style="gap: 5px;">
            <button class="btn btn-dark" (click)="add(Add,item)"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</button>
            <button class="btn btn-danger" (click)="deleteItem(item?.levelID)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button>
          </section>
        </td>
      </tr>
    </tbody>
  </table>
</section>

<section *ngIf="selMenu == 'roles'" class="mt-4" style="overflow-x: auto;height: 70vh;">
  <table class="table table-hover white_box shadow">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Role Name</th>
        <th scope="col">Role Description</th>
        <th scope="col">Level Assign</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of roleLevelList; let i = index;">
        <th scope="row">{{i + 1}}</th>
        <td><span class="sub-cate">{{item?.roleName | uppercase}}</span></td>
        <td>{{item?.description}}</td>
        <td>
          <ngx-slider [(value)]="item.minLevel" [(highValue)]="item.maxLevel" [options]="options"></ngx-slider>
        </td>
        <td class="text-right">
          <section class="d-flex justify-content-center" style="gap: 5px;">
            <button class="btn btn-dark" (click)="saveLevel(item)"><i class="fa fa-pencil" aria-hidden="true"></i> Save</button>
            <button class="btn btn-danger" (click)="deleteItem(item)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button>
          </section>
        </td>
      </tr>
    </tbody>
  </table>
</section>

<ng-template #Add let-modal>
  <div class="modal-body">
    <div class="add_cattt d-flex justify-content-between">
      <h2>Add Level</h2>
      <img loading="lazy" src="../../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
    </div>
    <form [formGroup]="form">
      <div class="referral-link">
        <section class="m-4">
          <div class="form-group">
            <input type="number" class="form-control" placeholder="Enter Level Number" maxlength="500" formControlName="id" />
          </div>

          <div class="form-group">
            <input type="text" class="form-control" placeholder="Enter Level Name" maxlength="500" formControlName="name" />
          </div>

          <div class="form-group">
            <textarea type="text" class="form-control" placeholder="Enter Level Description" maxlength="500" formControlName="description"></textarea>
          </div>
        </section>
        <div class="mt-4">
          <div class="cart_btn">
            <button class="com_btn add-review-btn px-2" (click)="addSubmit()">Save <i class="fa fa-save" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
